// extracted by mini-css-extract-plugin
module.exports = {"imageFallback":"images_imageFallback__2Ryq3"};